export default class AssessmentType {
  sortSequence: number;
  createdDate: Date;
  lookupCode: string;
  lookupValue: string;

  constructor(
    sortSequence: number,
    createdDate: Date,
    lookupCode: string,
    lookupValue: string
  ) {
    this.sortSequence = sortSequence;
    this.createdDate = createdDate;
    this.lookupCode = lookupCode;
    this.lookupValue = lookupValue;
  }
}

export enum AsmtTypeLookupCode {
  EVALUATION = "CL003.26",
}



// WEBPACK FOOTER //
// ./src/models/assessment/assessment-type.ts